/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */

export default function _buildSummaryNav() {
    // console.log('building summary panel navigation list');

    const summaryPanel = document.querySelector('div.summary-panel-navigation');
    const headerTwos = document.querySelectorAll('h2');
    const headerThrees = document.querySelectorAll('h3');

    let summaryPanelListItem = document.createElement('li');
    let summaryPanelAnchor = document.createElement('a');

    if (summaryPanel) {
        const summaryPanelList = summaryPanel.querySelector('ul');
        const summaryPanelHeaderClass = 'summary-panel-navigation__heading';
        const listItemClass = 'summary-panel-navigation__list__item';
        const listItemAnchorClass =
            'summary-panel-navigation__list__item__link';
        const summaryPanelEndPos = summaryPanel.offsetTop;

        summaryPanelList.innerHTML = '';
        for (let i = 0; i < headerTwos.length; i++) {
            if (
                headerTwos[i].offsetTop > summaryPanelEndPos &&
                !headerTwos[i].classList.contains(summaryPanelHeaderClass)
            ) {
                summaryPanelListItem = document.createElement('li');
                summaryPanelListItem.classList.add(listItemClass);
                summaryPanelAnchor = document.createElement('a');
                summaryPanelAnchor.classList.add(listItemAnchorClass);
                summaryPanelAnchor.appendChild(
                    document.createTextNode(headerTwos[i].innerText)
                );
                summaryPanelAnchor.title = headerTwos[i].innerText;
                let listItemAnchorHref = headerTwos[i].id
                    ? headerTwos[i].id
                    : `anchor-${i + 1}`;
                if (!headerTwos[i].id) {
                    headerTwos[i].id = listItemAnchorHref;
                }
                summaryPanelAnchor.href = `#${listItemAnchorHref}`;
                summaryPanelListItem.appendChild(summaryPanelAnchor);
                summaryPanelList.appendChild(summaryPanelListItem);
                if (headerTwos[i + 1]) {
                    for (let j = 0; j < headerThrees.length; j++) {
                        if (
                            headerTwos[i].offsetTop <=
                                headerThrees[j].offsetTop &&
                            headerThrees[j].offsetTop <
                                headerTwos[i + 1].offsetTop
                        ) {
                            summaryPanelListItem = document.createElement('li');
                            summaryPanelListItem.classList.add(listItemClass);
                            summaryPanelListItem.classList.add(
                                `${listItemClass}--sub`
                            );
                            summaryPanelAnchor = document.createElement('a');
                            summaryPanelAnchor.classList.add(
                                listItemAnchorClass
                            );
                            summaryPanelAnchor.appendChild(
                                document.createTextNode(
                                    headerThrees[j].innerText
                                )
                            );
                            summaryPanelAnchor.title =
                                headerThrees[j].innerText;
                            listItemAnchorHref = headerThrees[j].id
                                ? headerThrees[j].id
                                : `anchor-${i + 1}-${j + 1}`;
                            if (!headerThrees[j].id) {
                                headerThrees[j].id = listItemAnchorHref;
                            }
                            summaryPanelAnchor.href = `#${listItemAnchorHref}`;
                            summaryPanelListItem.appendChild(
                                summaryPanelAnchor
                            );
                            summaryPanelList.appendChild(summaryPanelListItem);
                        }
                    }
                } else {
                    for (let j = 0; j < headerThrees.length; j++) {
                        if (
                            headerTwos[i].offsetTop <= headerThrees[j].offsetTop
                        ) {
                            summaryPanelListItem = document.createElement('li');
                            summaryPanelListItem.classList.add(listItemClass);
                            summaryPanelListItem.classList.add(
                                `${listItemClass}--sub`
                            );
                            summaryPanelAnchor = document.createElement('a');
                            summaryPanelAnchor.classList.add(
                                listItemAnchorClass
                            );
                            summaryPanelAnchor.appendChild(
                                document.createTextNode(
                                    headerThrees[j].innerText
                                )
                            );
                            summaryPanelAnchor.title =
                                headerThrees[j].innerText;
                            listItemAnchorHref = headerThrees[j].id
                                ? headerThrees[j].id
                                : `anchor-${i + 1}-${j + 1}`;
                            if (!headerThrees[j].id) {
                                headerThrees[j].id = listItemAnchorHref;
                            }
                            summaryPanelAnchor.href = `#${listItemAnchorHref}`;
                            summaryPanelListItem.appendChild(
                                summaryPanelAnchor
                            );
                            summaryPanelList.appendChild(summaryPanelListItem);
                        }
                    }
                }
            }
        }
    }
}

setTimeout(() => _buildSummaryNav(), 0);
